import { render, staticRenderFns } from "./HandleUserAssociatingModal.vue?vue&type=template&id=28e0e57c&"
import script from "./HandleUserAssociatingModal.vue?vue&type=script&lang=ts&"
export * from "./HandleUserAssociatingModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports